<template>
<div>
    <!-- top header -->

    <header id="home" class="jumbotron jumbotron-fluid">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-8 col-md-4">
                    <router-link to="/">
                        <img class="img-fluid" src="../assets/logo.png" alt="Miriam Deblon">
                    </router-link>
                </div>
                <!-- <div class="col-4 col-md-2 col-lg-1"> -->
                <b-dropdown toggle-class="bg-transparent">
                    <template slot="button-content">
                        {{languageFull}}
                        <!-- <img class="img-fluid" :src="require('../assets/'+language+'.png')" /> -->
                    </template>
                    <b-dropdown-item @click="setLanguage('nl')">Nederlands</b-dropdown-item>
                    <b-dropdown-item @click="setLanguage('de')">Deutsch</b-dropdown-item>
                    <!-- <b-dropdown-item @click="setLanguage('sa')"><img class="img-fluid p-2" src="../assets/sa.png" /></b-dropdown-item> -->
                </b-dropdown>
                <!-- </div> -->
            </div>
        </div>
        <p></p>
        <navBar v-bind:items="menu"></navBar>
    </header>

    <!-- translations -->

    <heading id="translations" :title="readQuark('translations', 'title')"></heading>
    <div v-html="readQuark('translations', 'content')"> </div>

    <!-- <heading id="translations" title="Übersetzungen"></heading>
    <div class="container">
        <div class="row mt-4">
            <div class="col-md-7">
                <p>Professionelle Übersetzungen aus dem Niederländischen ins Deutsche:</p>
                <ul>
                    <li>sachkundig erstellt</li>
                    <li>gut durchdacht</li>
                    <li>bestens recherchiert</li>
                    <li>sorgfältig bearbeitet</li>
                    <li>Ihren Wünschen angepasst</li>
                </ul>
                <p>Spezialisiert auf juristische Fachübersetzungen für Unternehmen, Anwälte, Behörden und Gerichte.</p>
            </div>
            <div class="col">
                <img class="img-fluid" src="../assets/samuel-zeller-118195.jpg" />
            </div>
        </div>
    </div> -->

    <!-- portfolio -->

    <heading id="portfolio" :title="readQuark('portfolio', 'title')"></heading>
    <div v-html="readQuark('portfolio','content')"> </div>

    <!-- <heading id="portfolio" title="Arbeitsgebiete"></heading>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2>Spezialisierung!</h2>
                <p>Die bewusste Konzentration auf einige ausgewählte Fachgebiete garantiert eine hohe Übersetzungsqualität. Nur mit Fachwissen und Präzision lassen sich insbesondere Rechtstexte adäquat übersetzen. Ich recherchiere das Fachvokabular Ihrer
                    Texte eingehend und sorge <em>für korrekte terminologische Anwendung und Einheitlichkeit</em>.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-md-5">
                <img class="img-fluid" src="/uploads/aliis-sinisalu-70581.jpg" />
                <p></p>
                <p>Auf Grund meiner Ermächtigung vom Oberlandesgericht Hamm bin ich berechtigt, die Richtigkeit und Vollständigkeit der von mir erstellten Übersetzungen zu bestätigen.</p>
            </div>
            <div class="col-md-6 offset-md-1">
                <p>Recht</p>
                <ul>
                    <li>Arbeitsrecht</li>
                    <li>Eherecht</li>
                    <li>Erbrecht</li>
                    <li>Gesellschaftsrecht</li>
                    <li>Immobilien</li>
                    <li>Insolvenzen</li>
                    <li>Sozialrecht</li>
                    <li>Staatsangehörigkeitsrecht</li>
                    <li>Strafrecht</li>
                </ul>
            </div>
        </div>
    </div> -->

    <!-- about -->

    <heading id="about" :title="readQuark('about', 'title')"></heading>
    <div v-html="readQuark('about','content')"> </div>

    <!-- <heading id="about" title="Über mich"></heading>
    <div class="container">
        <h2>Ihre Spezialistin für die Sprachrichtung Niederländisch-Deutsch</h2>
        <div class="row">
            <div class="col-md-8">
                <h3>Erfahrung:</h3>
                <ul>
                    <li>Übersetzerstudium an der Universität Mainz, Fachbereich Angewandte Sprach- und Kulturwissenschaft in Germersheim; Diplom: 1987</li>
                    <li>Grundausbildung Bibliothek, Archiv und Dokumentation in Den Haag und Utrecht; Abschlusszeugnis: Juni 1990</li>
                    <li>Dozentin in den Niederlanden an der Fachhochschule in Maastricht, Studiengang Dolmetschen und Übersetzen, 1987 bis 1992</li>
                    <li>Hochschulzertifikat "Deutsche Rechtssprache" (Deutsche Gerichts- und Behördenterminologie für Übersetzer) der Hochschule für Wirtschaft und Umwelt Nürtingen-Geislingen; März 2010</li>
                    <li>Durch den Präsidenten des Oberlandesgerichts Hamm ermächtigt für die niederländische Sprache</li>
                    <li>Seit mehr als 25 Jahren als Übersetzerin tätig</li>
                </ul>
            </div>
            <div class="col-4">
                <img src="/uploads/IMG_4847.jpg" class="img-fluid" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <h3>Hohes Verantwortungsbewusstsein prägt meinen Arbeitsstil.</h3>
                <p>Genauigkeit und Sorgfalt beim Übersetzungsvorgang sind für mich selbstverständlich. Meine Übersetzungen sind flüssig lesbar und passend im Stil. Ich recherchiere das Fachvokabular Ihrer Texte eingehend und sorge für korrekte terminologische
                    Anwendung und Einheitlichkeit. </p>
                <p>Da ich mich außerdem flexibel auf Ihre Wünsche einstelle, können Sie von mir jederzeit Texte erwarten, die Ihre spezifischen Anforderungen erfüllen. </p>

                <h3>Mit Begeisterung</h3>
                <p>und Engagement bin ich für Sie bei der Sache. Ich liebe das Übersetzen und setze meine gesamten Fähigkeiten ein, für Sie die bestmöglichen Texte zu erstellen. Dabei gehe ich gern auf Ihre Sonderwünsche ein.</p>

                <h3>Zuverlässig liefere ich Ihre Übersetzungen</h3>
                <p>zum vereinbarten Termin. Ihre vertraulichen Dateien werden von mir verschlüsselt und mit absoluter Diskretion behandelt. Ihre Texte gebe ich nicht an Unterauftragnehmer weiter, sondern bearbeite sie ausschließlich selbst.</p>
            </div>
        </div>
    </div> -->

    <heading id="links" :title="readQuark('links', 'title')"></heading>
    <div v-html="readQuark('links','content')"> </div>

    <!-- <heading id="links" title="Interessante Links"></heading>
    <div class="container">
        <div class="row mt-3">
            <div class="col-md-5">
                <img class="img-fluid" src="/uploads/pexels-photo-618079.jpg" />
            </div>
            <div class="col-md-7">
                <p>Suchen Sie eine Fachkraft für <u>andere Sprachrichtungen</u>?</p>
                <p>Dann werden Sie auf der Website des Bundesverbands der Dolmetscher und Übersetzer (BDÜ) fündig: <a href="http://www.bdue.de">www.bdue.de</a>.</p>

                <p>Wissenswertes zum Thema <u>Terminologie</u> erfahren Sie auf der Website des Deutschen Terminologietags unter <a href="http://dttev.odg">http://dttev.odg.</a></p>

                <p>Den niederländischen Berufsverband NGTV (Nederlands Genootschap van Tolken en Vertalers) erreichen Sie unter <a href="https://ngtv.nl">https://ngtv.nl</a>.</p>
                <p>Auch dort können Sie über eine Suchmaske Übersetzer und Dolmetscher finden.</p>
            </div>
        </div>
    </div> -->

    <heading id="contact" :title="readQuark('contact', 'title')"></heading>
    <div v-html="readQuark('contact','content')"> </div>

    <!-- <heading id="contact" title="Kontakt"></heading>
    <div class="container">
        <h2>Ich freue mich darauf, Sie mit meiner Arbeit unterstützen zu können</h2>
        <div class="row">
            <div class="col-md-7">
                <p>Gerne erstelle ich für Sie ein kostenloses Angebot.</p>
                <p>Rufen Sie mich an oder schicken Sie eine Mail an Miriam.Deblon@t-online.de.</p>
                <p>Die Berechnung des Preises für <strong>Übersetzungen</strong> richtet sich:</p>
                <ul>
                    <li>ach der Anzahl der Wörter oder – auf Wunsch – nach der Anzahl der Zeilen (wobei eine Zeile aus 55 Anschlägen besteht);</li>
                    <li>nach dem Schwierigkeitsgrad des Textes;</li>
                    <li>nach der Form, in welcher der Text angeliefert wird.</li>
                </ul>
                <p>Gerne biete ich Ihnen <strong>Pauschalpreise</strong> an.</p>
                <p class="p-default">Miriam Deblon<br> Dipl.-Übersetzerin
                    <br> Fachübersetzungen | Niederländisch-Deutsch<br>
                    <p>Woortstraße 22 A<br> 48565 Steinfurt</p>
                    <p>T: +49 (0) 2552 702350<br> F: +49 (0) 2552 702351<br> M: Miriam.Deblon@t-online.de<br> I: www.deblon.de</p>
            </div>
            <div class="col-md-5">
                <img class="img-fluid" src="/uploads/freestocks-org-229658.jpg" alt="img-contact">
            </div>
        </div>
    </div> -->

    <heading id="impressum" :title="readQuark('impressum', 'title')"></heading>
    <div v-html="readQuark('impressum','content')"> </div>

    <!-- <heading id="impressum" title="Impressum"></heading>
    <div class="container">
        <div class="row mt-3">
            <div class="col-md-5">
                <img class="img-fluid" src="/uploads/system-2457648_1920.jpg" alt="img-contact">
            </div>
            <div class="col-md-6 offset-md-1">
                <div class="row">
                    <div class="col">
                        <h3>Verantwortlich:</h3>
                        <p>Miriam Deblon<br> Dipl.-Übersetzerin</p>
                        <p>Woortstraße 22 A<br> 48565 Steinfurt</p>
                    </div>
                    <div class="col">
                        <h3>&nbsp;</h3>
                        <p>T: +49 (0) 2552 702350<br> F: +49 (0) 2552 702351<br> M: Miriam.Deblon@t-online.de<br> I: www.deblon.de</p>
                    </div>
                </div>
                <p>Umsatzsteuer-Identifikationsnummer: DE 234290227</p>
                <br />
                <p>Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehme ich keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
            </div>
        </div>
    </div> -->

    <heading id="privacy" :title="readQuark('privacy', 'title')"></heading>
    <div v-html="readQuark('privacy','content')"> </div>



</div>
</template>

<script>
import navBar from './Navbar.vue'
import heading from './Heading.vue'
import axios from '../js/axios'
import utils from '../js/utils'

export default {
    data: () => ({
        language: 'de',
        languageFull: 'Deutsch',
        quarks: [],

        menu: '',
        menu_de: [
            'Home',
            'Übersetzungen',
            'Arbeitsgebiete',
            'Über mich',
            'Interessante Links',
            'Kontakt',
            'Impressum',
            'Datenschutz'
        ],
        menu_nl: [
            'Home',
            'Vertalingen',
            'Werkterreinen',
            'Over mijzelf',
            'Links',
            'Contact',
            'Colofon',
            'Privacy'
        ]
    }),

    components: {
        top,
        navBar,
        heading
    },

    created: function() {
        console.clear();
        this.menu = this.menu_de;
        this.getQuarks();
    },

    methods: {
        setLanguage(language) {
            console.log('setLanguage', language);

            this.language = language;
            if (language == 'de') {
                this.menu = this.menu_de;
                this.languageFull = 'Deutsch';
            }
            if (language == 'nl') {
                this.menu = this.menu_nl;
                this.languageFull = 'Nederlands';
            }
            this.getQuarks();
        },

        getQuarks() {
            let url = 'quarks/language/' + this.language;
            console.log('url', url);
            axios.getData(url).then(response => {
                this.quarks = response;
                console.log('quarks', this.quarks);
            });
        },

        readQuark(section, prop) {
            // console.log('readQuark', section, prop);
            let quark = '';
            this.quarks.forEach((element) => {
                if (element.section == section) {
                    switch (prop) {
                        case 'title':
                            quark = element.title;
                            break;
                        case 'content':
                            quark = element.content;
                            break;
                    }
                }
            });
            return quark;
        },
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
    color: #42b983;
}

.p-default {
    line-height: initial;
}
</style>
